import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-573f29fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "onboarding-forms page-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Website Intake Form Details")
], -1))
const _hoisted_2 = { class: "forms page" }
const _hoisted_3 = { class: "form-title" }
const _hoisted_4 = { class: "website-design-forms row" }
const _hoisted_5 = { class: "col-50" }
const _hoisted_6 = { class: "content-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Client Information ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Contact Email Address:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Company Name:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Company Email Address:", -1))
const _hoisted_11 = { class: "content-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Files Uploaded", -1))
const _hoisted_13 = { class: "file-row row" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "col-50" }
const _hoisted_16 = { class: "content-wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Project Information ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Project Details:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Website Purpose:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Target Market:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Custom Graphics Requirements:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Additional Info:", -1))
const _hoisted_23 = { class: "content-wrap" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Domain Information", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Domain Already Bought?", -1))
const _hoisted_26 = {
  key: 0,
  class: "already-bought-domain"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Domain Registrar:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Domain Login Username:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Domain Login Password:", -1))
const _hoisted_30 = { class: "content-wrap" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Social Media Links", -1))
const _hoisted_32 = {
  key: 0,
  class: "social-media-links"
}
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, "Form ID #: " + _toDisplayString(_ctx.$route.params.id), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", null, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.email_address), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.company_name), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.company_email_address), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            (_ctx.formData.files !== undefined || _ctx.formData.files !== null || _ctx.formData.files !== '')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.files, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "files",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", null, "File " + _toDisplayString(index + 1) + ":", 1),
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: ($event: any) => (_ctx.openLink(file))
                      }, "Open", 8, _hoisted_14)
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("p", null, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.detail_about_pages), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.website_purpose), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.target_market), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_21,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.graphics_details), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.additional_info), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("p", null, [
              _hoisted_25,
              _createTextVNode(" " + _toDisplayString(_ctx.formData.did_purchase_domain), 1),
              (_ctx.formData.did_purchase_domain === 'yes')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, [
                _hoisted_27,
                _createTextVNode(" " + _toDisplayString(_ctx.formData.domain_registrar_name), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.formData.domain_registrar_username), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_29,
                _createTextVNode(" " + _toDisplayString(_ctx.formData.domain_registrar_password), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            (_ctx.formData.social_media_links !== undefined || _ctx.formData.social_media_links !== null || _ctx.formData.social_media_links !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.social_media_links, (link, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createElementVNode("b", null, _toDisplayString(link.name) + ": ", 1),
                        _createElementVNode("a", {
                          class: "cursor",
                          onClick: ($event: any) => (_ctx.openSocialLink(link.link))
                        }, _toDisplayString(link.link), 9, _hoisted_33)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}